import { useEffect, useState } from 'react';

/**
 * A `Date` that refreshes once a minute.
 *
 * Next-run times are computed from a cron rather than fetched, so they go stale
 * on the wall clock, not on the network — "in 6h 12m" has to count down even
 * though no request is in flight. A minute is the right granularity: the
 * coarsest relative label is minutes, and it keeps the row memo recomputing
 * about sixty times an hour rather than on every render.
 *
 * Radix `Tabs` unmounts inactive `TabsContent`, so switching to the Runs tab
 * tears this interval down on its own.
 */
export function useMinuteTick(): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  return now;
}
